import { useEffect, useState } from 'react';
import { Note } from '../models/Note.interface';
import axios from 'axios';
import { useServiceDeskContext } from '../../../context/ServiceDesk/ServiceDeskContext';

export const useGetNotes = (
  axsTicketId: string | number,
  newNoteSubmitted: boolean
) => {
  const [notesData, setNotesData] = useState<Note[] | null>(null);
  const [loadingNotes, setLoadingNotes] = useState<boolean>(false);
  const { toggleInputField } = useServiceDeskContext();

  const getNotesData = async () => {
    try {
      setLoadingNotes(true);
      const { data } = (await axios.get(`api/annotations/${axsTicketId}`)) as {
        data: Note[];
      };

      if (data) {
        const formattedData = data?.map((data) => {
          return {
            ...data,
            createdby: {
              ...data.createdby,
              fullname: data?.createdby?.fullname,
            },
          };
        });
        setNotesData(formattedData);
        if (formattedData && formattedData.length != 0) {
          toggleInputField(true);
        } else {
          toggleInputField(false);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingNotes(false);
    }
  };

  useEffect(() => {
    getNotesData();
  }, [axsTicketId, newNoteSubmitted]);

  return {
    notesData,
    loadingNotes,
    getNotesData,
  };
};
